import { DropdownStylesSettings } from './DropdownStyles';

const DropdownText = ({ value, IconLeft, IconRight, iconSize = '16px', chipStyle, disabled }) => {
    const style = DropdownStylesSettings[chipStyle] || DropdownStylesSettings.Default;

    return (
        <>
            <div className="flex flex-1 flex-row items-center">
                {IconLeft && (
                    <div className="mr-2">
                        <IconLeft
                            style={{ width: iconSize, height: iconSize }}
                            fill={disabled ? style.iconColorDisabled : style.iconColor}
                        />
                    </div>
                )}
                {value && <div className="font-normal mt-0.5">{value}</div>}
            </div>
            {IconRight && (
                <div>
                    <IconRight
                        style={{ width: iconSize, height: iconSize }}
                        fill={disabled ? style.iconColorDisabled : style.iconColor}
                    />
                </div>
            )}
        </>
    );
};

export default DropdownText;
